import { Badge, Card } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { apiReqSearchDeviceForMain } from 'src/api/management.api';
import { addComma, getTimeStringByDate } from 'src/utils/StringUtil';

const CustomTooltip: FC<any> = ({ active, payload, label }) => {
   if (active) {
      const { value: value1, stroke: stroke1 } = payload[0];
      const { value: value2, stroke: stroke2 } = payload[1];

      return (
         <div className="customTooltip">
            <span className="customTooltip-title">{label}</span>
            <ul className="customTooltip-content">
               <li key="viewCount">
                  <Badge color={stroke1} />
                  시청자수 {addComma(value1)}
               </li>
               <li key="viewRate">
                  <Badge color={stroke2} />
                  시청률 {value2}%
               </li>
            </ul>
         </div>
      );
   }

   return null;
};

const StatisticGraph: FC<{ loading: boolean }> = ({ loading }) => {
  const [chartData, setChartData] = useState<
      { name: string; viewCount: number; viewRate: string }[]
   >([]);
   
   useEffect(() => {
      let today = new Date();
      let prevDay = new Date(new Date().setDate(new Date().getDate() - 59));
      let startDate = getTimeStringByDate(prevDay, 'YYYY-MM-DD', false, false);
      let endDate= getTimeStringByDate(today, 'YYYY-MM-DD', false, false);
      console.log(startDate+"~"+endDate);
      apiReqSearchDeviceForMain({ startDate, endDate }).then(res => {
        const formattedData = res.data.list.map((item: any) => ({
           name: moment(item.date).format('MM/DD'),
           viewCount: item.viewCount,
           viewRate: ((item.viewCount / item.playCount) * 100).toFixed(2),
        }));
        setChartData(formattedData);
     });
   }, []);

   return (
      <Card loading={loading} style={{ marginTop: 12 }} bordered={false}>
         <ResponsiveContainer height={250}>
            <LineChart data={chartData} syncId="anyId">
               <XAxis dataKey="name" />
               <YAxis yAxisId="left" hide/>
               <YAxis yAxisId="right" orientation="right" hide />
               <CartesianGrid strokeDasharray="3 3" />
               <Tooltip content={<CustomTooltip />} />
               <Line type="monotone" dataKey="viewCount" stroke="#3F90F7" name="시청자수" yAxisId="left"/>
               <Line type="monotone" dataKey="viewRate" stroke="#ff4d4f" name="시청률" yAxisId="right"/>
               <Legend
                  verticalAlign="top"
               />
            </LineChart>
         </ResponsiveContainer>
      </Card>
   );
};

export default StatisticGraph;
